// GRX
export const DEFAULT_INPUT_CURRENCY = 'GRX'
// TST as default output currency for GRX Chain
export const DEFAULT_OUTPUT_CURRENCY = '0xb2c15A6f8eB7d87acc2D5edfb4300cf5fa620081'
